import React from 'react';
import { Trophy } from 'lucide-react';
import type { LeaderboardEntry } from '../../../types/ranking';

interface LeaderboardTableProps {
  data: LeaderboardEntry[];
  isLoading: boolean;
}

const LeaderboardTable: React.FC<LeaderboardTableProps> = ({ data, isLoading }) => {
  return (
    <div className="overflow-x-auto min-h-[400px]"> {/* Added min-height */}
      {isLoading ? (
        <div className="flex items-center justify-center h-[400px] text-content-secondary">
          Loading rankings...
        </div>
      ) : !data.length ? (
        <div className="flex items-center justify-center h-[400px] text-content-secondary">
          No rankings available yet
        </div>
      ) : (
        <table className="w-full">
          <thead className="border-b border-gray-800">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-content-secondary">
                Rank
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-content-secondary">
                Animatronic
              </th>
              <th className="px-4 py-3 text-right text-sm font-semibold text-content-secondary">
                Score
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-800">
            {data.map((entry, index) => (
              <tr key={entry.id} className="hover:bg-background/50">
                <td className="px-4 py-3 text-content-secondary">
                  {index === 0 && (
                    <Trophy className="w-4 h-4 text-yellow-500 inline mr-1" />
                  )}
                  {index + 1}
                </td>
                <td className="px-4 py-3 text-content-primary">
                  {entry.name}
                </td>
                <td className="px-4 py-3 text-right text-content-secondary">
                  {Math.round(entry.elo_score)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default LeaderboardTable;